import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=6f3804aa&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=6f3804aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3804aa",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/page_not_found.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FPageNotFound.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports